import { render, staticRenderFns } from "./quotation_details.vue?vue&type=template&id=68f6277a&"
import script from "./quotation_details.vue?vue&type=script&lang=js&"
export * from "./quotation_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports